<template>
    <div>
      <div class="modal fade" id="login" tabindex="-1" aria-labelledby="loginLabel" aria-hidden="true" data-bs-backdrop="false" style="background-color:rgba(0, 0, 0, 0.5);">
          <div class="modal-dialog modal-fullscreen">
              <div class="modal-content" :style="skin.side_bar.body">
                  <div class="modal-header2 p-0" style="">
                      
                  </div>
                  <div class="modal-body" style="height:30%;">
                    <img v-if="!skin.lobby" class="img-login" :src="skin.imagen.login" alt="">
                      <div class="" style="z-index: 2;position: relative;">
                          <div class="text-center">
                              <div class="text-start ">
                                <span id="closeLogin" class="title" type="button" data-bs-dismiss="modal"><i class="fas fa-chevron-left me-2"></i>{{ translate('enter') }}</span>
                              </div>
                              <form @submit.prevent="login()">
                                  <div class="pb-2 font-size-custom mb-3 my-3 text-start" style="color:white;">
                                      <label class="mb-2" for="username">{{ translate('user') }}<span style="color: red;">*</span></label>
                                      <div class="search-filter-slots-desktop__input-wrapper" :style="skin.my_account.search">
                                          <div class="search-filter-slots-desktop__input">
                                              <div class="input-desktop" :style="skin.my_account.search">
                                              <input id="username" v-model="username"
                                              class="input-desktop__native input-desktop__native_color_default input-desktop__native_type_search-slots"
                                              type="text" name="slots-search" :placeholder="translate('user')" value="" :style="skin.my_account.search"></div>
                                          </div>
                                      </div>
                                  </div>
                                  <div v-if="!resetPassword" class="pb-2 font-size-custom mb-3 my-3 text-start" style="color:white;">
                                      <label class="mb-2" for="password">{{ translate('password') }} <span style="color: red;">*</span></label>
                                      <div class="search-filter-slots-desktop__input-wrapper" :style="skin.my_account.search">
                                          <div class="search-filter-slots-desktop__input">
                                              <div class="input-desktop" :style="skin.my_account.search">
                                              <input id="password" v-model="password" autocomplete="off"
                                              class="input-desktop__native input-desktop__native_color_default input-desktop__native_type_search-slots"
                                              type="password" name="slots-search" :placeholder="translate('password')" value="" :style="skin.my_account.search"></div>
                                          </div>
                                      </div>
                                  </div>
                                  <div v-if="skin.reset_password" class="text-end mb-3">
                                      <span @click="reset_password()" style="text-decoration: underline;cursor:pointer;">{{ translate("forgot_password") }}</span>
                                  </div>
                                  <div class="" style="cursor:pointer;overflow: hidden;border-radius: 6.25rem;">
                                      <!-- <button class="btn p-2 mx-2" type="button" style="background-color: #292d3d!important;color:white;width:50%" data-bs-dismiss="modal" aria-label="Close">CANCELAR</button> -->
                                      <button id="submit_btn" type="submit" class="p-2 login-btn" :style="skin.header_desktop.nav_bar_text+skin.header_desktop.selection" :disabled="login_inProcess">{{ translate('enter') }}</button>
                                  </div>
                              </form>
                              <div v-if="status.message!=''" :class="'alert alert-'+status.type" role="alert">{{ status.message }}</div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
    </div>
  </template>
  
  <script>
  import axios from 'axios';
  export default {
      name:"login_mobil",
      props:['skin','translation','language'],
      data(){
          return {
              username:"",
              password:"",
              resetPassword:false,
              status:{
                  message:"",
                  type:""
              },
              login_inProcess:false
          }
      },
      computed:{
      },
      methods:{
          async login(){
              this.login_inProcess = true;
              if(this.resetPassword){
                  if(this.username!=""){
                      let reset = await axios.post(this.$store.getters["getDomain"]+"/swarm/remote/forgot_password",{
                          "email":this.username
                      })
                      if(reset.data.success){
                          this.status.message=reset.data.message;
                          this.status.type="success";
                      }
                      else{
                          this.status.message=reset.data.message;
                          this.status.type="danger";
                      }
                      this.resetPassword = false;
                  }
                  else{
                      this.status.message=this.translate("input_email");
                      this.status.type="danger"; 
                  }
                  this.login_inProcess = false;
              }
              else{
                  let data = await this.$store.dispatch('login',{username:this.username,password:this.password});
                  if(data=="success"){
                      document.getElementById('closeLogin').click();
                      this.$root.$emit('forceRender');
                      this.login_inProcess = false;
                      this.username = '';
                      this.password = '';
                      this.status.message = '';
                  }
                  else{
                      this.status.message=data;
                      this.status.type="danger";
                      this.login_inProcess = false;
                  }
              }
              
          },
          reset_password(){
              this.resetPassword = true;
              this.login();
          },
          translate(text) {
              if(text){
                  if (this.$props.translation[text]) {
                      return this.$props.translation[text][this.$props.language];
                  }
                  else{
                      var new_text_serched = text.replace(/ /g, "_");
                      if (this.$props.translation[new_text_serched]) {
                          return this.$props.translation[new_text_serched][this.$props.language];
                      }
                  }
                  return text;
              }
          },
      }
  }
  </script>
  
  <style scoped>
  .close2 {
      float: right;
      font-size: 1.5rem;
      font-weight: 700;
      line-height: 1;
      color: #000;
      text-shadow: 0 1px 0 #fff;
      opacity: .5;
  }
  .title {
  font-weight: 700;
  font-size: 1.1rem;
  line-height: 100%;
  color: #fff;
  font-family: 'Roboto', Arial, sans-serif;
  }
  .search-filter-slots-desktop__input-wrapper{
      -webkit-box-flex: 2;
      -ms-flex-positive: 2;
      flex-grow: 2;
      height: 40px;
      width: 100%;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      margin-right: .625rem;
      /* background: linear-gradient(180deg, #320548 0%, #1f073a 100%); */
      /* background: linear-gradient(180deg, #320548 0%, #1f073a 100%); */
      /* border: var(--border); */
      border-radius: 6.25rem;
      overflow: hidden;
      position: relative;
      overflow: hidden;
      padding-left: .938rem;
  }
  .search-filter-slots-desktop__search-icon {
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      -webkit-box-pack: center;
      -ms-flex-pack: center;
      justify-content: center;
  }
  .search-filter-slots-desktop__input {
      -webkit-box-flex: 2;
      -ms-flex-positive: 2;
      flex-grow: 2;
  }
  .input-desktop {
      -webkit-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;
      width: 100%;
      height: 100%;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      position: relative;
  }
  .search-filter-slots-desktop__input input {
      padding-left: .625rem;
      border: none;
      color: var(--color);
      font-weight: 600;
      font-size: .875rem;
  }
  .input-desktop__native {
      width: 100%;
      height: 100%;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      padding: 0 1.25rem;
      outline: none;
      border-radius: 5px;
      color: white;
      font-family: "Roboto", Arial, sans-serif;
      font-size: .875rem;
      font-weight: 700;
      line-height: .875rem;
  }
  .login-btn{
      width: 100%;
      border:none;
  }
  .img-login {
      content: "";
      position: absolute;
      top: 30%;
      z-index: 1;
      width: 100%;
  }
  </style>